module.exports = __webpack_public_path__ + "static/media/JustActMailers_7_V2-01.57235f63.jpg";